<template>
    <div>
      <!-- Selezione tab. -->
      <v-tabs background-color="primary" color="white" centered>

        <!-- Tab "Header". -->
        <v-tab @click="tab_attivo = 0"> Header </v-tab>

        <!-- Il tab "Filtri" è disattivato se non è selezionato un header. -->
        <!-- Qualora venisse cliccato, esegui un refresh dei filtri se necessario. -->
        <v-tab @click="tab_attivo = 1; $refs.tabFiltri.getRicaricamentoFiltri();" :disabled="!modulo_header"> Filtri </v-tab>

        <!-- Il tab "Preview" è work-in-progress, si spacca molto facilmente. -->
        <v-tab @click="tab_attivo = 2; getHeaderFiltriPreview();"> Preview </v-tab>

      </v-tabs>
      
      <!-- @send_modulo => Evento per ottenere il modulo dell'header. -->
      <!-- @send_tabella => Evento per ottenere la tabella dell'header. -->
      <GestioneHeader v-show="tab_attivo == 0" @send_modulo="getModuloHeader" @send_tabella="getTabellaHeader"/>

       <!-- Passa il modulo dell'header ai filtri (non modificabile). -->
      <GestioneFiltri ref="tabFiltri" v-show="tab_attivo == 1" :modulo_header="modulo_header"/>

      <v-card v-if="tab_attivo == 2">
        <v-toolbar dense color="primary" dark align="center">
          <v-toolbar-title>Preview</v-toolbar-title>
            <v-spacer/>
              <!-- Visualizza / nascondi barra filtri. -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn light
                    small
                    class="mr-5"
                    v-bind="attrs"
                    v-on="on"
                    @click="filtri_visible = !filtri_visible"
                  >
                    <v-icon v-if="!filtri_visible" color="purple lighten-2"
                      >mdi-filter</v-icon
                    >
                    <v-icon v-else color="purple lighten-2">mdi-filter-off</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ filtri_visible ? "Nascondi filtri" : "Visualizza filtri" }}
                </span>
              </v-tooltip>
            <v-spacer/>
          <!-- Pulsante indietro. -->
          <v-btn small light @click="$router.push('/home/amministrazione')">
            <v-icon color="error">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </v-toolbar>


        <!-- Filtri. -->
        <span v-show="filtri_visible == true">
          <InputFiltri :lista_filtri="filtri" @applica_filtri="applicaFiltri" />
        </span>

        <!-- Modulo e tabella. -->
        <v-card-text>
          <v-row align="center" justify="center">
            <v-col cols="6">
              <v-text-field hide-details readonly type="text" label="Modulo" v-model="modulo_header"/>
            </v-col>
            <v-col cols="3">
              <v-text-field hide-details readonly type="text" label="Tabella" v-model="tabella_header"/>
            </v-col>
          </v-row>
        </v-card-text>


        <!-- Tabella preview. -->
        <v-data-table :headers="headers" :items="lista_preview">
        </v-data-table>
        
      </v-card>

    <!-- Snackbar. -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Overlay caricamento. -->
    <v-overlay color="rgba(0, 0, 0, 1)" style="position: absolute" :value="caricamento_dati">
      <v-icon class="ConsuntivoWORuota" size="100">mdi-cog</v-icon>
      <v-icon class="ConsuntivoWOControruota" size="100">mdi-cogs</v-icon>
    </v-overlay>

    </div>
</template>

<script>
import SnackbarQV from '@/components/TOOLS/SnackbarQV.vue';
import InputFiltri from '@/components/TOOLS/InputFiltri.vue';
export default {
  name: "GestioneHeaderFiltri",
  components: {
    GestioneHeader: () => import("@/components/AMMINISTRAZIONE/HEADER_FILTRI/GestioneHeader.vue"),
    GestioneFiltri: () => import("@/components/AMMINISTRAZIONE/HEADER_FILTRI/GestioneFiltri.vue"),
    SnackbarQV,
    InputFiltri
  },
  data() {
    return {
      tab_attivo: 0,
      modulo_header: "",
      tabella_header: "",
      caricamento_dati: false,
      filtri_visible: false,

      lista_preview: [],
      filtri: [],
      filtri_query: [],
      headers: []
    };
  },
  methods: {
    applicaFiltri(lista_filtri) {
      this.filtri_query = lista_filtri;
      this.getHeaderFiltriPreview();
    },
    getModuloHeader(modulo) {this.modulo_header = modulo;},
    getTabellaHeader(tabella) {this.tabella_header = tabella;},

    getHeaderFiltriPreview() {

      if(!this.modulo_header || !this.tabella_header) {
        this.$refs.SnackbarQV.print("orange", "Specificare in \"Header\" modulo e tabella.");
        return;
      }

      this.headers = [];
      this.lista_preview = [];
      this.filtri = [];
      
      let request = {
        controller: "magazzino",
        method: "POST",
        richiesta: {
          action: "getheaderfiltripreview",
          modulo: this.modulo_header,
          tabella: this.tabella_header,
          filtri: this.filtri_query,
          token: localStorage.getItem("user_token"),
        },
      };

      this.filtri_query = [];

      this.caricamento_dati = true;
      this.$store.dispatch("api6", request)
      .then((res) => {
        this.caricamento_dati = false;
        if (res.status == 200) {
          this.headers = res.data.result.t_header ? res.data.result.t_header : [];
          this.filtri = res.data.result.filtri ? res.data.result.filtri : [];
          this.lista_preview = res.data.result.preview ? res.data.result.preview : [];

          if(this.lista_preview.length > 0) this.$refs.SnackbarQV.print("success", "Preview caricata correttamente.");
          else this.$refs.SnackbarQV.print("orange", "Nessun risultato trovato.");

        } else {
          this.$refs.SnackbarQV.print("orange", "Problemi nel caricamento.");
        }
      })
      .catch((err) => {
        this.caricamento_dati = false;
         this.$refs.SnackbarQV.print("error", err);
      });
    }
  }
}
</script>

<style scoped>
/* Overlay */
@keyframes ConsuntivoWOControtazione {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes ConsuntivoWORotazione {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ConsuntivoWOControruota {
  animation: ConsuntivoWOControtazione 1s infinite;
  animation-timing-function: linear;
}

.ConsuntivoWORuota {
  animation: ConsuntivoWORotazione 1s infinite;
  animation-timing-function: linear;
}
/* *** */
</style>